import { c as _c } from "react/compiler-runtime";
import { useViewPort } from "@website/hooks/viewport";
import throttle from "lodash-es/throttle";
import { useEffect, useRef, useState } from "react";
export const useScroll = () => {
  const $ = _c(12);
  const [scrollReference, setScrollReference] = useState(null);
  const [scrolled, setScrolled] = useState(false);
  const scrollPosition = useRef(0);
  const {
    isDesktop
  } = useViewPort();
  let t0;
  let t1;
  if ($[0] !== isDesktop || $[1] !== scrollReference || $[2] !== scrolled) {
    t0 = () => {
      const scrollListener = () => {
        if (scrollReference && scrollReference && scrollReference.scrollTop) {
          if (scrolled && scrollPosition.current > scrollReference.scrollTop) {
            setScrolled(false);
          } else {
            if (!scrolled && scrollPosition.current < scrollReference.scrollTop) {
              setScrolled(true);
            }
          }
          scrollPosition.current = scrollReference.scrollTop;
        }
      };
      const scrollListenerThrottle = throttle(scrollListener, 100);
      if (scrollReference && !isDesktop) {
        scrollReference.addEventListener("scroll", scrollListenerThrottle);
      }
      return () => {
        if (scrollReference && !isDesktop) {
          scrollReference.removeEventListener("scroll", scrollListenerThrottle);
        }
      };
    };
    t1 = [scrollReference, scrolled, isDesktop];
    $[0] = isDesktop;
    $[1] = scrollReference;
    $[2] = scrolled;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  let t2;
  if ($[5] !== isDesktop || $[6] !== scrollReference) {
    t2 = () => {
      if (scrollReference && !isDesktop) {
        scrollReference.scrollTo(0, 0);
      }
    };
    $[5] = isDesktop;
    $[6] = scrollReference;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const scrollToTop = t2;
  let t3;
  if ($[8] !== scrollReference || $[9] !== scrollToTop || $[10] !== scrolled) {
    t3 = {
      scrollReference,
      setScrollReference,
      scrolled,
      setScrolled,
      scrollToTop
    };
    $[8] = scrollReference;
    $[9] = scrollToTop;
    $[10] = scrolled;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};